import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TailwindMerge } from '@shared/src/interfaces/TwMerge.interface';
import { StepperItemComponent } from '@shared/src/lib/components/stepper/stepper-item/stepper-item.component';
import { StepperItem } from '@shared/src/lib/components/stepper/stepper-item/stepper-item.interface';

@Component({
  selector: 'lib-stepper',
  standalone: true,
  imports: [NgFor, StepperItemComponent],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.css',
})
export class StepperComponent extends TailwindMerge {
  @Input() options: StepperItem.WorkflowHistory[] = [];
  @Input() activeStepper: StepperItem.WorkflowOption | null = null;

  get featureSteps(): StepperItem.WorkflowHistory[] {
    return this.options;
  }
}
